import AdminConfig from './admin';

import ClientView from './client';


export default {
  name : 'publipostword',

  type : 'module',
  
  label: 'publipostage word',

  components: {

    admin: AdminConfig,

    client: ClientView

  },

  settings: {
    icon: 'mdi-file-word',
  }
}